module.exports = __webpack_public_path__ + "success-ani.7b7fb0da336a9e8c5ffd805449a7e87e.hashedasset.svg";